export const API_GET_MULTILANGUAGE_CONTENT = '/contents';
